import Icon, { IconProps } from 'components/Icon';
import { FC } from 'react';

interface Props extends Omit<IconProps, 'name'> {
  name?: IconProps['name'];
}

const MobileIcon: FC<Props> = (props) => (
  <Icon
    name="place"
    size={20}
    color="greys.steel"
    bg="greys.alto"
    p={1}
    display={['block', 'none']}
    position="absolute"
    top="5px"
    left="0"
    {...props}
  />
);

export default MobileIcon;
